import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import React, { memo, useState } from "react";
import TextError from "../../../TextError";
import {
  CloseOutlined,
  CheckOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Input,
  message,
  Modal,
  Select,
  Skeleton,
  Spin,
} from "antd";
import * as Yup from "yup";
import Autocomplete from "react-google-autocomplete";
import { useDispatch } from "react-redux";
import {
  checkblackedlist,
  loctionFromfreightify,
} from "../../../../store/SearchRates/SearchRatesSlice";
//import { REACT_APP_GOOGLE_MAP_API_KEY } from "../../../../utils/secondsToTime";

const options = [
  { label: "PORT", value: "PORT" },
  { label: "DOOR", value: "DOOR" },
];

/**
 * Origin selector. The PORT/DOOR mode comes from the parent (originType) — the
 * old inline PORT/DOOR dropdown was removed. Added props:
 *   • multiple / maxCount — CY port field becomes a multi-select (CY->CY, max 8),
 *     stored in originShipment as a "&&"-joined string.
 *   • doorToDoor — when the side is DOOR, render TWO fields: Door (max 3, mirrors
 *     to originLocation to keep the payload) + CY ports (max 10, UI-only).
 */
const OriginShipmentNew = ({
  formikData,
  setAnchorEl,
  shipPorts,
  allshipports,
  originType,
  setOriginType,
  originShipment,
  setOriginShipment,
  originlocation,
  setOriginLocation,
  multiple,
  maxCount = 8,
  doorToDoor,
}) => {
  let msg = "Country name is not equal";
  // const [originLocation, setOriginLocation] = useState(
  //   formikData?.values?.originShipment?.originLocation
  // );
  // const [originLocationMarker, setOriginLocationMarker] = useState(
  //   formikData?.values?.originShipment?.originLocationMarker
  // );
  // const [originLocationCountry, setOriginLocationCountry] = useState(
  //   formikData?.values?.originShipment?.originLocationCountry
  // );

  const [spin, setSpin] = useState(false);
  const dispatch = useDispatch();
  const [locationOptions, setLocationOptions] = useState([]);

  // DOOR -> DOOR extra fields (UI only). Door mirrors to originLocation to keep
  // the current payload behaviour; the CY list is not sent anywhere for now.
  const [doorList, setDoorList] = useState([]);
  const [cyList, setCyList] = useState([]);
  const handleDoorChange = (vals) => {
    const capped = (vals || []).slice(0, 3);
    setDoorList(capped);
    setOriginLocation(capped.join("&&"));
  };
  const handleCyChange = (vals) => setCyList((vals || []).slice(0, 10));

  const errorModal = (msg) => {
    Modal.error({
      title: msg,
      onOk() {
        formikData.setFieldValue("originShipment.originShipment", "");
        formikData.setFieldValue("originShipment.originLocation", "");
        formikData.setFieldValue("originShipment.originPickup", "");
        formikData.setFieldValue("originShipment.originLocationMarker", {});
        formikData.setFieldValue("originShipment.originPortMarker", {});
        formikData.setFieldValue("originShipment.originLocationCountry", "");
        formikData.setFieldValue("destinationShipment.destinationShipment", "");
        formikData.setFieldValue("destinationShipment.destinationLocation", "");
        formikData.setFieldValue("destinationShipment.destinationPickup", "");
        formikData.setFieldValue(
          "destinationShipment.destinationLocationMarker",
          {}
        );
        formikData.setFieldValue(
          "destinationShipment.destinationPortMarker",
          {}
        );
        formikData.setFieldValue(
          "destinationShipment.destinationLocationCountry",
          ""
        );
        formikData.setFieldValue("containerDetails.incoTerms", "");
      },
      okButtonProps: {
        style: {
          color: "#ffffff",
          backgroundColor: "#FFAF00",
        },
      },
    });
  };
  // const setFieldValuesData = (
  //   originShipment,
  //   originpickup,
  //   originportmarker
  // ) => {
  //   setSpin(true);

  //   formikData.setFieldValue("originShipment.originShipment", originShipment);
  //   formikData.setFieldValue("originShipment.originLocation", originLocation);
  //   formikData.setFieldValue("originShipment.originPickup", originpickup);
  //   formikData.setFieldValue(
  //     "originShipment.originPortMarker",
  //     originLocationMarker
  //   );
  //   formikData.setFieldValue(
  //     "originShipment.originLocationMarker",
  //     originLocationMarker
  //   );
  //   formikData.setFieldValue(
  //     "originShipment.originLocationCountry",
  //     originLocationCountry
  //   );
  //   setSpin(false);
  // };

  const onSubmit = (values, setprops) => {
    console.log("valueocean", values);

    // if (values.originpickup && values.originlocation === "") {
    //   setprops.setFieldError("originlocation", "Origin location is required");
    // } else {
    //   if (
    //     formikData.values.destinationShipment.destinationShipment &&
    //     formikData.values.containerDetails.incoTerms !== ""
    //   ) {
    //     const desiShipmentData = allshipports?.find((item) => {
    //       return (
    //         formikData.values.destinationShipment.destinationShipment ===
    //         `${item.port_name} - (${item.port_code})`
    //       );
    //     });
    //     const originShipmentData = allshipports?.find((item) => {
    //       return (
    //         values.originShipment === `${item.port_name} - (${item.port_code})`
    //       );
    //     });

    //     if (
    //       (originShipmentData?.country_name?.toLowerCase() === "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() === "india") ||
    //       formikData.values.destinationShipment.destinationShipment ===
    //         values.originShipment
    //     ) {
    //       if (
    //         formikData.values.destinationShipment.destinationShipment ===
    //         values.originShipment
    //       ) {
    //         msg = "Shipment not allowed!";
    //       } else {
    //         msg = "Local shipment is not allowed!";
    //       }
    //       errorModal(msg);
    //     } else {
    //       // if(formikData.values.containerDetails.incoTerms === ''){
    //       if (
    //         originShipmentData?.country_name?.toLowerCase() === "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         formikData.values.containerDetails.incoTerms === ''
    //       ) {
    //         console.log( 'cfr',originShipmentData?.country_name?.toLowerCase() === "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india" )
    //         formikData.setFieldValue("containerDetails.incoTerms", "CFR");
    //         formikData.setFieldValue("containerDetails.vaslist", {"originServices":["Origin Cargo Stuffing","Origin Transportation","Origin Customs Clearance","Origin CFS Clearance"],"destinationServices":[]});
    //       } else if (
    //         originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() === "india" && formikData.values.containerDetails.incoTerms === ''
    //       ) {
    //         console.log('fob', originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() === "india" )
    //         formikData.setFieldValue("containerDetails.incoTerms", "FOB");
    //         formikData.setFieldValue("containerDetails.vaslist", {"destinationServices":["Destination Cargo Handling","Destination Customs Clearance","Destination Transportation","Destination CFS Clearance"]});
    //       } else if (
    //         originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india"
    //          && formikData.values.containerDetails.incoTerms === ''
    //       ) {
    //         console.log("third" ,originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india"  )
    //         formikData.setFieldValue(
    //           "containerDetails.incoTerms",
    //           "Third Country"
    //         );
    //         formikData.setFieldValue("containerDetails.vaslist", "");
    //       }
    //       const originportmarker = {
    //         lat: originShipmentData?.lat,
    //         lng: originShipmentData?.lon,
    //       };
    //       if (
    //         originLocationCountry &&
    //         (originShipmentData?.country_name).toLowerCase() !==
    //           originLocationCountry.toLowerCase()
    //       ) {
    //         errorModal(msg);
    //       } else {
    //         setFieldValuesData(
    //           values.originShipment,
    //           values.originpickup,
    //           originportmarker
    //         );
    //       }
    //     }
    //   } else {
    //     const originShipmentData = allshipports?.find((item) => {
    //       return (
    //         values.originShipment === `${item.port_name} - (${item.port_code})`
    //       );
    //     });
    //     if (formikData.values.containerDetails.incoTerms === "") {
    //       if (originShipmentData?.country_name?.toLowerCase() === "india") {
    //         console.log("cfr",originShipmentData?.country_name?.toLowerCase() === "india")
    //         formikData.setFieldValue("containerDetails.incoTerms", "CFR");
    //         formikData.setFieldValue("containerDetails.vaslist", {"originServices":["Origin Cargo Stuffing","Origin Transportation","Origin Customs Clearance","Origin CFS Clearance"],"destinationServices":[]});
    //       } else {
    //         formikData.setFieldValue("containerDetails.incoTerms", "FOB");
    //         formikData.setFieldValue("containerDetails.vaslist",{"destinationServices":["Destination Cargo Handling","Destination Customs Clearance","Destination Transportation","Destination CFS Clearance"]});
    //       }
    //     }
    //     const originportmarker = {
    //       lat: originShipmentData?.lat,
    //       lng: originShipmentData?.lon,
    //     };
    //     if (
    //       originLocationCountry &&
    //       (originShipmentData?.country_name).toLowerCase() !==
    //         originLocationCountry.toLowerCase()
    //     ) {
    //       errorModal(msg);
    //     } else {
    //       setFieldValuesData(
    //         values.originShipment,
    //         values.originpickup,
    //         originportmarker
    //       );
    //     }
    //   }
    // }

    //   const originShipmentData = allshipports?.find((item) => {
    //       return (
    //         values.originShipment === `${item.port_name} - (${item.port_code})`
    //       );
    //     });

    // setFieldValuesData(
    //   values.originShipment,
    //   values.originpickup,
    //   originportmarker
    // );
  };
  const initialValues = {
    originShipment: formikData?.values?.originShipment?.originShipment,
    // originlocation: originLocation||"",
    originlocation: "",
    originpickup: formikData?.values?.originShipment?.originPickup,
  };
  const validationSchema = Yup.object().shape({
    originShipment: Yup.string().required("Please select Origin Shipment"),
    //originlocation:Yup.string().required("Origin Location is required"),
  });

  const handleSearch = (value) => {
    dispatch(
      loctionFromfreightify({
        searchText: value,
        countryCode: "IN", // dynamic if needed
        mode: "SEA-PORT",
      })
    ).then((res) => {
      if (res?.payload?.status === 200) {
        const data = res?.payload?.data || [];

        setLocationOptions(
          data.map((item) => ({
            value: item.name,
            label: `${item.name} (${item.code})`,
          }))
        );
      } else {
        message.error("Something went wrong");
      }
    });
  };

  // const x = dispatch(loctionFromfreightify(values)).then((res) => {
  //   console.log("res", res);
  //   if (res?.payload?.status === 200) {
  //     setOpenBackdrop(false);
  //   } else {
  //     message.error("Something went wrong");
  //     setOpenBackdrop(false);
  //   }
  // });

  return (
    // <div className=" bg-white">
    //   <Skeleton active loading={shipPorts !== undefined ? false : true}>
    //     <Formik
    //       onSubmit={onSubmit}
    //       initialValues={initialValues}
    //       validationSchema={validationSchema}
    //     >
    //       {(formik) => {
    //         return (
    //           <Form>
    //             <div className="grid grid-cols-12 gap-6">
    //               <div className="sm:col-span-12 col-span-12 flex justify-between items-center gap-2">
    //                 <Select
    //                   value={originType}
    //                   onChange={(val) => setOriginType(val)}
    //                   id="originType"
    //                   name="originType"
    //                   showSearch
    //                   className="py-1 leading-4 focus:border focus:outline-0 w-full min-w-[120px] text-xs font-normal border rounded-md"
    //                   bordered={false}
    //                   placeholder="PORT / DOOR"
    //                   optionFilterProp="children"
    //                   filterOption={(input, option) =>
    //                     (option?.label?.toLowerCase() ?? "").includes(
    //                       input.toLowerCase()
    //                     )
    //                   }
    //                   filterSort={(optionA, optionB) =>
    //                     (optionA?.label ?? "")
    //                       .toLowerCase()
    //                       .localeCompare((optionB?.label ?? "").toLowerCase())
    //                   }
    //                   options={[
    //                     { label: "PORT", value: "PORT" },
    //                     { label: "DOOR", value: "DOOR" },
    //                   ]}
    //                   dropdownStyle={{ zIndex: 9999 }}
    //                 />
    //                 {originType === "PORT" && (
    //                   <SelectField options={shipPorts} formik={formik} />
    //                 )}
    //                 {originType === "DOOR" && (
    //                   <div>
    //                     <div className="relative">
    //                       {/* <Field type='text' innerRef={ref} id='originlocation' name='originlocation' placeholder="Enter Origin Location" className="leading-4 px-4 py-3 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md z-[10000]"/> */}
    //                       <Autocomplete
    //                         apiKey={config.googleMapApiKey}
    //                         className="leading-4 pl-4 pr-9 py-3 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md z-[10000]"
    //                         placeholder="Enter Origin Location"
    //                         options={{
    //                           types: [
    //                             "neighborhood",
    //                             "locality",
    //                             "sublocality",
    //                             "postal_code",
    //                             "point_of_interest",
    //                           ],
    //                           fields: [
    //                             "address_components",
    //                             "geometry",
    //                             "icon",
    //                             "name",
    //                             "place_id",
    //                             "formatted_address",
    //                           ],
    //                         }}
    //                         value={originLocation}
    //                         name="originlocation"
    //                         onChange={(e) => {
    //                           setOriginLocation(e.target.value);
    //                           formik.setFieldValue(
    //                             "originlocation",
    //                             e.target.value
    //                           );
    //                         }}
    //                         onPlaceSelected={(place) => {
    //                           setOriginLocation(place.formatted_address);
    //                           setOriginLocationMarker({
    //                             lat: place.geometry.location.lat(),
    //                             lng: place.geometry.location.lng(),
    //                           });
    //                           const countryName = place.address_components.find(
    //                             (component) =>
    //                               component.types.includes("country")
    //                           ).long_name;
    //                           setOriginLocationCountry(countryName);
    //                         }}
    //                       />
    //                       <EnvironmentOutlined className="absolute right-4 top-3 text-gray-400" />
    //                     </div>
    //                     <ErrorMessage
    //                       name="originlocation"
    //                       component={TextError}
    //                     />
    //                   </div>
    //                 )}
    //               </div>

    //               {/* <div className="sm:col-span-12 col-span-6">
    //                 <div className="flex items-center">
    //                   <Field
    //                     type="checkbox"
    //                     id="originpickup"
    //                     name="originpickup"
    //                     className="w-5 h-5 rounded mx-5"
    //                   />
    //                   <label
    //                     htmlFor="originpickup"
    //                     className="py-2 block text-sm font-normal leading-5 text-formlabel"
    //                   >
    //                     Require pickup from origin location
    //                   </label>
    //                 </div>
    //               </div>
    //               <div className="sm:col-span-12 col-span-6 flex items-center sm:justify-center justify-end gap-5">
    //                 <button
    //                   type="button"
    //                   onClick={() => {
    //                     setAnchorEl(null);
    //                   }}
    //                   className="text-primary bg-white hover:bg-secondary hover:text-white font-bold leading-4 rounded-lg text-sm px-4 py-2 text-center  flex items-center justify-center gap-2 shadow-searchbox border-2 border-primary"
    //                 >
    //                   <CloseOutlined />
    //                   <span>Cancel</span>
    //                 </button>
    //                 <button
    //                   type="submit"
    //                   className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox"
    //                 >
    //                   {spin ? (
    //                     <Spin />
    //                   ) : (
    //                     <>
    //                       <CheckOutlined />
    //                       <span>Confirm</span>
    //                     </>
    //                   )}
    //                 </button>
    //               </div> */}
    //             </div>
    //           </Form>
    //         );
    //       }}
    //     </Formik>
    //   </Skeleton>
    // </div>

    <div className="bg-white">
      <Skeleton active loading={shipPorts !== undefined ? false : true}>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          // validationSchema={validationSchema}
        >
          {(formik) => {
            return (
              <Form>
                <div className="grid grid-cols-12 gap-6">
                  {/* Flex Container for the Row */}
                  <div className="col-span-12 flex items-start gap-2">
                    {/* PORT / DOOR is now driven by the CY / DOOR toggle in the
                        parent (originType prop); the inline dropdown is removed. */}
                    <div className="flex-1 w-full">
                      {originType === "PORT" && (
                        // Ensure SelectField component has w-full and h-[42px] inside it
                        <SelectField
                          options={shipPorts}
                          formik={formik}
                          originShipment={originShipment}
                          setOriginShipment={setOriginShipment}
                          multiple={multiple}
                          maxCount={maxCount}
                          className="w-full"
                        />
                      )}

                      {originType === "DOOR" && (
                        <div>
                          {/* <div className="relative w-full">
                            <Autocomplete
                              apiKey={config.googleMapApiKey}
                              // Adjusted padding (py-3) to match height of the left box
                              className="h-[42px] leading-4 pl-4 pr-9 py-2.5 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md z-[10000]"
                              placeholder="Port / Google location" // Updated placeholder to match image
                              options={{
                                types: [
                                  "neighborhood",
                                  "locality",
                                  "sublocality",
                                  "postal_code",
                                  "point_of_interest",
                                ],
                                fields: [
                                  "address_components",
                                  "geometry",
                                  "icon",
                                  "name",
                                  "place_id",
                                  "formatted_address",
                                ],
                              }}
                              value={originLocation}
                              name="originlocation"
                              onChange={(e) => {
                                setOriginLocation(e.target.value);
                                formik.setFieldValue(
                                  "originlocation",
                                  e.target.value
                                );
                              }}
                              onPlaceSelected={(place) => {
                                setOriginLocation(place.formatted_address);
                                setOriginLocationMarker({
                                  lat: place.geometry.location.lat(),
                                  lng: place.geometry.location.lng(),
                                });
                                const countryName =
                                  place.address_components.find((component) =>
                                    component.types.includes("country")
                                  ).long_name;
                                setOriginLocationCountry(countryName);
                              }}
                            />
                            <EnvironmentOutlined className="absolute right-4 top-3 text-gray-400" />
                          </div>
                          <ErrorMessage
                            name="originlocation"
                            component={TextError}
                          /> */}

                          {doorToDoor ? (
                            <>
                              {/* Door locations (max 3) */}
                              <div className="relative w-full">
                                <Select
                                  mode="multiple"
                                  placeholder="Select Origin Door"
                                  onSearch={handleSearch}
                                  options={locationOptions}
                                  value={doorList}
                                  onChange={handleDoorChange}
                                  filterOption={false}
                                  bordered={false}
                                  className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                  allowClear
                                  showSearch
                                  getPopupContainer={(t) => t.parentNode}
                                />
                                <div className="text-right mt-1">
                                  <span className="sr-loc-count">
                                    {doorList.length} / 3
                                  </span>
                                </div>
                              </div>

                              {/* Nearby CY ports (max 10) — UI only for now */}
                              <div className="relative w-full mt-2">
                                <Select
                                  mode="multiple"
                                  placeholder="Select Origin CY"
                                  options={shipPorts}
                                  value={cyList}
                                  onChange={handleCyChange}
                                  optionFilterProp="label"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  bordered={false}
                                  className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                  allowClear
                                  showSearch
                                  getPopupContainer={(t) => t.parentNode}
                                />
                                <div className="text-right mt-1">
                                  <span className="sr-loc-count">
                                    {cyList.length} / 10
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="relative w-full">
                              <AutoComplete
                                // style={{ width: 350 }}
                                placeholder="Select Origin Door"
                                onSearch={handleSearch}
                                options={locationOptions}
                                value={originlocation}
                                onChange={(val) => setOriginLocation(val || "")}
                                onSelect={(val) => setOriginLocation(val || "")}
                                onClear={() => setOriginLocation("")}
                                bordered={false}
                                className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                allowClear
                                showSearch
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Skeleton>
    </div>
  );
};

const PORT_DELIM = "&&";

const SelectField = memo(
  ({
    options,
    formik,
    originShipment,
    setOriginShipment,
    multiple,
    maxCount = 8,
  }) => {
    const { setFieldValue } = useFormikContext();

    // Multi-select (CY -> CY): value is the "&&"-joined string split into an
    // array; selections are capped at maxCount (antd 5.1.4 has no maxCount).
    if (multiple) {
      const selected = originShipment
        ? String(originShipment).split(PORT_DELIM).filter(Boolean)
        : [];
      const handleMultiChange = (vals) => {
        const capped = (vals || []).slice(0, maxCount);
        setOriginShipment(capped.join(PORT_DELIM));
      };
      return (
        <Select
          mode="multiple"
          value={selected}
          onChange={handleMultiChange}
          id="originShipment"
          name="originShipment"
          showSearch
          className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md"
          bordered={false}
          placeholder="Select Origin Shipment"
          optionFilterProp="label"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={options}
          dropdownStyle={{ zIndex: 9999 }}
        />
      );
    }

    const handleChange = (value) => {
      setOriginShipment(value);
    };
    return (
      <>
        <Select
          value={originShipment ? originShipment : "Select Origin Shipment"}
          onChange={handleChange}
          id="originShipment"
          name="originShipment"
          showSearch
          className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md"
          bordered={false}
          placeholder="Select Origin Shipment"
          optionFilterProp="children"
          filterOption={(input, option) =>
            ((option?.label).toLowerCase() ?? "").includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={options}
          dropdownStyle={{ zIndex: 9999 }}
        />
        {/* <ErrorMessage name="originShipment" component={TextError} /> */}
      </>
    );
  }
);
export default React.memo(OriginShipmentNew);
